//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInfo } from '@/api/my'
import { packageList, packageAppraise, packagePurchased } from '@/api/create'
import global from '../../assets/js/global'
import { createPayLog, payWxBrower, queryOrder, payForm, queryAlipayOrder, alipayForm, wxPay, discount, getDiscountList, createDisCountOrder } from '@/api/buy'
import { Toast } from 'vant'
export default {
  name: 'subscribe',
  data: function () {
    return {
      title: '订阅中心',
      renounceModal: false,
      unlockModal: false,
      list: [],
      currentGif: {},
      giftModal: false,
      top: 0,
      bottom: 0,
      contentH: 0,
      isWechat: false,
      systemType: '',
      positionY: 0,
      buyIndex: 0,
      payMethodIndex: 0,
      orderInfo: '',
      orderNo: '',
      buyItem: {},
      userInfo: {},
      timer: null,
      dataList: [],
      iosDataList: [
        {
          title: '按年订阅',
          yj: 198,
          xj: 58,
          dj: 0.1,
          unit: '天',
          isHot: true
        },
        {
          title: '按月订阅',
          yj: 68,
          xj: 20,
          dj: 0.66,
          unit: '天',
          isHot: false
        },
        {
          title: '按周订阅',
          yj: 30,
          xj: 10,
          dj: 1.42,
          unit: '天',
          isHot: false
        },
        {
          title: '一天尝鲜包',
          yj: 30,
          xj: 10,
          dj: 5,
          unit: '天',
          isHot: false
        },
        {
          title: '10次体验包',
          yj: 30,
          xj: 10,
          dj: 1,
          unit: '次',
          isHot: false
        }
      ],
      disCountData: {},
      hours: 23,
      minutes: 59,
      seconds: 59,
      appraiseList: [],
      isWindowsWechat: false,
      code: '',
      payLogId: '',
      wxAppId: 'wx312b0d62d88de1ab', // 公众号
      redirectUri: '',
      purchasedList: []
    }
  },
  created () {
    this.redirectUri = process.env.BASE_URL + '/subscribe'
    this.type = this.$route.query.type;
    this.systemType = global.systemType
    if (global.isApp) {
      if (this.type === "nobalance") {
        api.toast({
          msg: "您的使用次数已用完，可订阅会员获取无限次提问次数",
          duration: 3000,
          location: "bottom",
        });
      }
      this.top = api.safeArea.top
      this.bottom = api.safeArea.bottom
    } else {
      this.getDiscountList()
      if (this.type === "nobalance") {
        Toast({
          message: '您的使用次数已用完，可订阅会员获取无限次提问次数',
          duration: 3000,
          position: 'bottom',
        });
      }
      let browser = navigator.userAgent.toLowerCase()
      let isWechat = browser.includes('micromessenger')
      this.isWindowsWechat = browser.includes('windowswechat')
      this.isWechat = isWechat
      if (this.isWechat) {
        this.payMethodIndex = 1
      }
      this.code = this.getQueryString('code')
      if (this.code) {
        // this.payLogId = this.getQueryString('state')
        console.log('code: ', this.code)
        // console.log('payLogId: ',this.payLogId)
        this.beforeWxpayH5(this.payLogId)
      }
    }
    this.getOrderDetail()
    console.log('subscribe created')
    this.getData()
    this.getUser()
    this.type = parseInt(this.$route.query.type)
    this.positionY = document.documentElement.clientHeight - 89
    console.log(this.positionY)
  },
  mounted () {
    document.addEventListener('visibilitychange', this.showDialog)
    this.$bus.$on('changeCoupon', (val) => {
      this.currentGif = val
    })
  },
  activated () {
    console.log('activated')
    console.log('subscribe activated')
  },
  destroyed () {
    this.renounceModal = true
    clearInterval(this.timer)
    document.removeEventListener('visibilitychange', this.showDialog)
  },
  methods: {
    showDialog () {
      if (document.visibilityState === 'visible') {
        console.log('11111', 'visibili')
        this.getOrderDetail()
      }
    },
    getData () {
      packageList().then(res => {
        this.dataList = res.data
        if (this.dataList.length) {
          this.buyItem = this.dataList[0]
        }
      })
      packageAppraise().then(res => {
        console.log(res)
        this.appraiseList = res.data
      })
      packagePurchased().then(res => {
        console.log(res)
        this.purchasedList = res.data
      })
    },
    back () {
      discount().then(res => {
        this.disCountData = res.data
        this.renounceModal = false
        if (res.data.total > 0) {
          this.giftModal = true
          this.getTime()
        } else {
          this.goBack()
        }
      })
    },
    addZero (n) {
      return n < 10 ? '0' + n : n
    },
    getTime () {
      let date = new Date()
      let tomorrowDate = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate() + 1,
        date.getHours(), date.getMinutes(), date.getSeconds())
      let tomorrow = tomorrowDate.getTime() - date.getTime()
      clearTimeout(this.timer)
      this.timer = setInterval(() => {
        tomorrow -= 1000
        var hours = this.addZero(parseInt((tomorrow % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        var minutes = this.addZero(parseInt((tomorrow % (1000 * 60 * 60)) / (1000 * 60)));
        var seconds = this.addZero(parseInt(tomorrow % (1000 * 60) / 1000));
        this.hours = hours
        this.minutes = minutes
        this.seconds = seconds
      }, 1000)
    },
    goBack () {
      clearInterval(this.timer)
      this.$router.replace({
        path: '/home'
      })
    },
    giftUse () {
      if (!this.list.length) {
        this.getDiscountList()
      } else {
        let list = this.list.filter(item => item.discountType === 0).sort((a, b) => b.discountAmount - a.discountAmount)
        if (list.length) {
          this.currentGif = list[0]
        } else {
          this.currentGif = {}
        }
        clearInterval(this.timer)
        this.giftModal = false
      }
    },
    onClickLeft () {
      if (!this.userInfo.dueTime) {
        this.renounceModal = true
      } else {
        this.$router.replace({
          path: '/home'
        })
      }
      // this.$router.replace({
      //   path: '/home'
      // })
    },
    goSetting () {
      this.$router.push({
        path: '/setting'
      })
    },
    getUser () {
      getInfo().then(res => {
        this.userInfo = res.data
      })
    },
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      }
      return null
    },
    goAliPay (res) {
      this.$router.replace({
        path: '/subscribe',
        query: {
          out_trade_no: res.data.payLog.orderNo,
          type: 0
        }
      })
      document.body.removeChild(document.getElementById('pay-box'))
    },
    goWechatPay (res) {
      this.$router.replace({
        path: '/subscribe',
        query: {
          out_trade_no: res.data.payLog.orderNo,
          type: 1
        }
      })
      location.href = res.data.mwebUrl
    },
    doWxLogin () {
      this.$router.push({
        path: '/login?type=1'
      })
    },
    beforeAlipay (payLogId) {
      payForm({
        payLogId: payLogId
      }).then(res => {
        console.log(JSON.stringify(res))
        this.orderInfo = res.data.form
        this.doAlipay()
      })
    },
    doAlipay () {
      var aliPayPlus = api.require('aliPayPlus');
      let _this = this
      aliPayPlus.payOrder({
        orderInfo: this.orderInfo
      }, function (ret, err) {
        console.log(ret.code)
        _this.payResult(ret.code * 1)
      });
    },
    goCoupon () {
      this.$router.push({
        path: '/coupon',
        query: {
          id: this.buyItem.id
        }
      })
    },
    payResult (code) {
      switch (code) {
        case 9000: //支付成功
          this.showResult('支付成功')
          break;
        case 8000: //正在处理中，支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
          // Toast('支付成功')
          this.checkOrder()
          break;
        case 4000: //订单支付失败
          this.showResult('支付失败')
          break;
        case 5000: //重复请求
          this.showResult('订单重复请求')
          break;
        case 6001: //用户中途取消支付操作
          this.showResult('支付取消')
          break;
        case 6002: //网络连接出错
          this.showResult('网络连接出错')
          break;
        case 6004: //支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
          // Toast('支付成功')
          this.checkOrder()
          break;
        default:
          break;
      }
    },
    showResult (msg) {
      console.log(msg)
      api.toast({
        msg: msg,
        duration: 2000,
        location: 'middle'
      });
    },
    checkOrder () {
      queryAlipayOrder({
        outTradeNo: this.orderNo
      }).then(res => {
        if (res.data.payStatus === 1) {
          Toast('支付成功')
        } else {
          Toast('支付失败')
        }
      })
    },
    createOrder () {
      if (this.isWindowsWechat) {
        this.$toast('请在手机端下单')
        return
      }
      if (global.isApp) {
        if (!localStorage.getItem('openId')) {
          this.doWxLogin()
        } else {
          createPayLog({
            packageId: this.buyItem.id
          }).then(res => {
            console.log(JSON.stringify(res))
            this.orderNo = res.data.orderNo
            this.beforeAlipay(res.data.id)
          })
        }
      } else {
        let fn = createPayLog
        let params = {
          id: this.dataList[this.buyIndex].id
        }
        if (this.currentGif.id) {
          delete params.type
          fn = createDisCountOrder
          params.id = this.currentGif.id
        }
        console.log(params)
        fn(params).then(res => {
          console.log(res)
          if (this.isWechat) {
            this.beforeWxpayH5(res.data.id)
            // this.getWxAuthCode(res.data.id)
            return
          }
          if (this.payMethodIndex === 0) {
            alipayForm({
              payLogId: res.data.id
            }).then(res => {
              console.log(res)
              const div = document.createElement('div');
              div.id = 'pay-box'
              div.innerHTML = res.data.form;
              document.body.appendChild(div);
              // document.getElementById('pay-box').children[0].setAttribute('target', '_blank')
              document.getElementById('pay-box').children[0].submit();
              this.goAliPay(res)
            })
          } else {
            wxPay({
              payLogId: res.data.id
            }).then(res => {
              console.log(res)
              this.goWechatPay(res)
            })
          }
        })
      }
    },
    getDiscountList () {
      getDiscountList({
        pageNum: 1,
        pageSize: 50
      }).then(res => {
        this.list = res.data.list.filter(item => item.status === '1')
        let list = this.list.filter(item => item.discountType === 0).sort((a, b) => b.discountAmount - a.discountAmount)
        if (list.length) {
          this.currentGif = list[0]
        } else {
          this.currentGif = {}
        }
        clearInterval(this.timer)
        this.giftModal = false
      })
    },
    getWxAuthCode (payLogId) {
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.wxAppId + '&redirect_uri=' + encodeURIComponent(this.redirectUri) + '&response_type=code&scope=snsapi_base&state=' + payLogId + '#wechat_redirect'
    },
    beforeWxpayH5 (payLogId) {
      payWxBrower({
        // code: this.code,
        payLogId: payLogId
      }).then(res => {
        console.log(JSON.stringify(res))
        // this.orderInfo = res.data.form
        this.doWxPayH5(res.data)
      })
    },
    doWxPayH5 (res) {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: res.appId, // 公众号名称，由商户传入
          timeStamp: res.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.paySign
        },
        (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            this.unlockModal = true
            this.getDiscountList()
            this.getUser()
            // this.$router.push({
            //   path: '/home'
            // })
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            this.$toast('支付被取消')
            // this.$router.push({
            //   path: '/home'
            // })
          } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
            this.$toast('支付失败')
            // this.$router.push({
            //   path: '/home'
            // })
          }
        }
      )
    },
    getOrderDetail () {
      if (!this.$route.query.out_trade_no) return
      let str = '请在支付宝内完成支付，如果您已支付成功，请点击"已完成支付"按钮。'
      if (this.$route.query.type === '1') {
        str = '请在微信内完成支付，如果您已支付成功，请点击"已完成支付"按钮。'
      }
      this.$dialog.confirm({
        closeOnPopstate: false,
        title: '支付确认',
        message: str,
        confirmButtonText: '已完成支付'
      })
        .then(() => {
          let fn = queryAlipayOrder
          let params = {
          }
          if (this.$route.query.type == 1) {
            fn = queryOrder
            params.orderSn = this.$route.query.out_trade_no
          } else {
            params.outTradeNo = this.$route.query.out_trade_no
          }
          fn(params).then(res => {
            if (this.$route.query.type == 1) {
              if (res.data.tradeState === 'SUCCESS') {
                this.getDiscountList()
                this.unlockModal = true
                setTimeout(() => {
                  this.getUser()
                }, 1000)
              } else {
                Toast('未支付')
              }
            } else {
              if (res.data.payStatus === 1) {
                this.unlockModal = true
                this.getDiscountList()
                setTimeout(() => {
                  this.getUser()
                }, 1000)
              } else {
                Toast('未支付')
              }
            }
          })
        })
    },
    chooseItem (item, index) {
      this.buyIndex = index
      this.buyItem = item
      console.log(item)
      let list = this.list.filter(obj => obj.packageId === item.id).sort((a, b) => b.discountAmount - a.discountAmount)
      console.log(list)
      if (list.length) {
        this.currentGif = list[0]
      } else {
        this.currentGif = {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/subscribe.vue